export var linkPreferencesPath = '/manage-profile/link-preferences';